import { useState } from 'react';

import { Modal } from './Modal';

/**
 * Confirmación de acciones destructivas o sensibles. Con `pedirMotivo` exige un texto (se guarda
 * en la auditoría o en el registro, p. ej. el motivo de revocar una licencia).
 */
export function ConfirmarAccion({
  abierto,
  onCerrar,
  titulo,
  descripcion,
  textoBoton,
  peligro = false,
  pedirMotivo,
  ocupado = false,
  onConfirmar,
}: {
  abierto: boolean;
  onCerrar: () => void;
  titulo: string;
  descripcion: string;
  textoBoton: string;
  peligro?: boolean;
  pedirMotivo?: string;
  ocupado?: boolean;
  onConfirmar: (motivo: string) => void;
}) {
  const [motivo, setMotivo] = useState('');
  const falta = pedirMotivo !== undefined && motivo.trim().length < 3;
  return (
    <Modal
      abierto={abierto}
      onCerrar={() => {
        setMotivo('');
        onCerrar();
      }}
      titulo={titulo}
      descripcion={descripcion}
    >
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          if (!falta) onConfirmar(motivo.trim());
        }}
      >
        {pedirMotivo !== undefined && (
          <label className="block">
            <span className="mb-1.5 block text-sm font-bold text-texto-2">{pedirMotivo}</span>
            <input
              className="input-vidrio"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              autoFocus
              maxLength={200}
            />
          </label>
        )}
        <div className="flex justify-end gap-2">
          <button type="button" className="btn-cs btn-contorno" onClick={onCerrar}>
            Cancelar
          </button>
          <button
            type="submit"
            className={`btn-cs ${peligro ? 'btn-peligro' : 'btn-primario'}`}
            disabled={ocupado || falta}
          >
            {ocupado ? 'Procesando…' : textoBoton}
          </button>
        </div>
      </form>
    </Modal>
  );
}
